module.exports = __webpack_public_path__ + "img/kilo-pink.59f0329a.svg";